import classNames from 'classnames'
import Link from 'next/link'

import Icon, { EDHRECIconsType } from '@/components/Icon/Icon'

import styles from './LegalityChip.module.scss'

type Props = {
  bracket: string
  href: string
  state: 'success' | 'warning' | 'error'
}

const ICON_MAP: Record<Props['state'], EDHRECIconsType> = {
  error: 'xMark',
  success: 'check',
  warning: 'exclamation',
}

const LegalityChip = ({ bracket, href, state }: Props) => {
  return (
    <Link className={classNames(styles.chip, styles[state])} href={`${href}#bracket-info`}>
      <Icon icon={ICON_MAP[state]} />
      &nbsp;&nbsp;{bracket}
    </Link>
  )
}

export default LegalityChip
